<template>
  <div ref="userIconTrigger" class="user-icon" @click="toggleModal">
    <font-awesome-icon icon="user-circle" size="2x" class="user-avatar" />

    <Teleport to="body">
      <div
        v-if="showMenu"
        class="modal-overlay"
        :style="menuOverlayStyle"
        @click.stop="closeModal"
      >
        <div ref="menuContent" class="modal-content" @click.stop>
        <div class="menu-header">
          <span class="signed-in-text">Signed in as</span>
          <span class="user-name">{{ userName }}</span>
        </div>
        <nav class="menu-nav">
          <a
            v-if="roles.includes('admin')"
            href="#"
            class="menu-item"
            @click.prevent="navigate('/users')"
          >
            <font-awesome-icon icon="user-shield" class="menu-icon" />
            <span>Manage Users</span>
          </a>
          <a
            v-if="roles.includes('admin') || roles.includes('manager')"
            href="#"
            class="menu-item"
            @click.prevent="navigate('/calls')"
          >
            <font-awesome-icon icon="phone" class="menu-icon" />
            <span>Ringba Calls</span>
          </a>
          <a
            v-if="roles.includes('admin') || roles.includes('customer')"
            href="#"
            class="menu-item"
            @click.prevent="navigate('/billable_report')"
          >
            <font-awesome-icon icon="coins" class="menu-icon" />
            <span>Billable Report</span>
          </a>
          <a
            v-if="roles.includes('admin')"
            href="#"
            class="menu-item"
            @click.prevent="navigate('/')"
          >
            <font-awesome-icon icon="chart-bar" class="menu-icon" />
            <span>Dnq report</span>
          </a>
          <a
            v-if="roles.includes('admin')"
            href="#"
            class="menu-item"
            @click.prevent="navigate('/per_week')"
          >
            <font-awesome-icon icon="calendar-week" class="menu-icon" />
            <span>Weekly Fulfillment</span>
          </a>
          <a
            v-if="roles.includes('admin') || roles.includes('manager')"
            href="#"
            class="menu-item"
            @click.prevent="navigate('/agents')"
          >
            <font-awesome-icon icon="users" class="menu-icon" />
            <span>Agents & Teams</span>
          </a>
          <a
            v-if="roles.includes('admin') || roles.includes('manager')"
            href="#"
            class="menu-item"
            @click.prevent="navigate('/agent_performance')"
          >
            <font-awesome-icon icon="chart-bar" class="menu-icon" />
            <span>Agent Performance</span>
          </a>
          <a
            v-if="roles.includes('admin')"
            href="#"
            class="menu-item"
            @click.prevent="navigate('/settings')"
          >
            <font-awesome-icon icon="cogs" class="menu-icon" />
            <span>Settings</span>
          </a>
          <a
            v-if="roles.includes('cross_sales_configurator')"
            href="#"
            class="menu-item"
            @click.prevent="navigate('/Calls_quota')"
          >
            <font-awesome-icon icon="table" class="menu-icon" />
            <span>Cross sales configurator</span>
          </a>
          <a
            v-if="roles.includes('admin') || roles.includes('QA')"
            href="#"
            class="menu-item menu-item-refund"
            @click.prevent="navigate('/refund_requests')"
          >
            <font-awesome-icon icon="undo" class="menu-icon" />
            <span>Refund Requests</span>
            <span v-if="pendingRefundCount > 0" class="refund-badge">{{ pendingRefundCount }}</span>
          </a>
          <router-link to="/profile" class="menu-item" @click="closeModal">
            <font-awesome-icon icon="user" class="menu-icon" />
            <span>Profile</span>
          </router-link>
        </nav>
        <div class="menu-footer">
          <a href="#" class="menu-item menu-item-signout" @click.prevent="logout">
            <font-awesome-icon icon="sign-out-alt" class="menu-icon" />
            <span>Sign out</span>
          </a>
        </div>
      </div>
    </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  name: 'UserMenu',
  props: {
    roles: { type: Array, default: () => [] },
    userName: { type: String, default: '' },
  },
  data() {
    return {
      showMenu: false,
      pendingRefundCount: 0,
      menuOverlayStyle: {},
    };
  },
  mounted() {
    this.fetchPendingRefundCount();
  },
  methods: {
    updateMenuPosition() {
      const el = this.$refs.userIconTrigger;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const gap = 8;
      this.menuOverlayStyle = {
        position: 'fixed',
        top: `${rect.bottom + gap}px`,
        right: `${window.innerWidth - rect.right}px`,
        left: 'auto',
        width: '260px',
        zIndex: '99999',
      };
    },
    toggleModal() {
      this.showMenu = !this.showMenu;
      if (this.showMenu) {
        this.$nextTick(() => {
          this.updateMenuPosition();
          document.addEventListener('click', this.handleClickOutside);
          window.addEventListener('scroll', this.updateMenuPosition, true);
          window.addEventListener('resize', this.updateMenuPosition);
        });
      } else {
        document.removeEventListener('click', this.handleClickOutside);
        window.removeEventListener('scroll', this.updateMenuPosition, true);
        window.removeEventListener('resize', this.updateMenuPosition);
      }
    },

    closeModal() {
      this.showMenu = false;
      document.removeEventListener('click', this.handleClickOutside);
      window.removeEventListener('scroll', this.updateMenuPosition, true);
      window.removeEventListener('resize', this.updateMenuPosition);
    },

    handleClickOutside(event) {
      const trigger = this.$refs.userIconTrigger;
      const menu = this.$refs.menuContent;
      if (trigger && trigger.contains(event.target)) return;
      if (menu && menu.contains(event.target)) return;
      this.closeModal();
    },

    navigate(path) {
      this.closeModal();
      this.$router.push(path);
    },

    async logout() {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          await fetch('/api/logout', {
            method: 'POST',
            headers: { Authorization: `Bearer ${token}` },
            body: JSON.stringify({ username: localStorage.getItem('username') }),
          });
        } catch (e) {
          console.error('Logout error:', e);
        }
      }
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      window.location.href = '/login';
    },

    async fetchPendingRefundCount() {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch('/api/refund_requests/pending_count', {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) return;
        const data = await res.json();
        this.pendingRefundCount = data.count || 0;
      } catch (e) {
        console.error('Failed to fetch pending refund count', e);
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
    window.removeEventListener('scroll', this.updateMenuPosition, true);
    window.removeEventListener('resize', this.updateMenuPosition);
  },
};
</script>

<style scoped>
.user-icon {
  position: relative;
  cursor: pointer;
  color: #000;
  transition: color 0.2s ease, transform 0.2s ease;
}
.user-icon:hover {
  color: #1a1a1a;
  transform: scale(1.05);
}
.user-avatar {
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.2));
}

.modal-overlay {
  position: fixed;
  min-height: 0;
  background: transparent;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  pointer-events: none;
}
.modal-overlay .modal-content {
  pointer-events: auto;
}

.modal-content {
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow:
    0 10px 40px rgba(0, 0, 0, 0.12),
    0 4px 12px rgba(0, 0, 0, 0.08),
    0 0 0 1px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  min-width: 240px;
  overflow: hidden;
  animation: menuEnter 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.modal-content::before {
  content: '';
  position: absolute;
  top: -6px;
  right: 16px;
  width: 12px;
  height: 12px;
  background: #fff;
  transform: rotate(45deg);
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.06);
}

@keyframes menuEnter {
  0% {
    opacity: 0;
    transform: translateY(-8px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.menu-header {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  color: #fff;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.signed-in-text {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  opacity: 0.85;
}
.user-name {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
  word-break: break-word;
}

.menu-nav {
  display: flex;
  flex-direction: column;
  padding: 6px 0;
}
.menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
  border: none;
  cursor: pointer;
  background: transparent;
  width: 100%;
  text-align: left;
  position: relative;
}
.menu-item:hover {
  background: #f3f4f6;
  color: #1e3c72;
}
.menu-item .menu-icon {
  width: 16px;
  color: #6b7280;
  flex-shrink: 0;
}
.menu-item:hover .menu-icon {
  color: #2a5298;
}
.menu-item span:first-of-type {
  flex: 1;
}

.menu-item-refund {
  position: relative;
  padding-right: 36px;
}
.refund-badge {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  line-height: 1;
  pointer-events: none;
  box-shadow: 0 2px 6px rgba(220, 38, 38, 0.4);
}

.menu-footer {
  border-top: 1px solid #e5e7eb;
  padding: 6px 0;
  background: #fafafa;
}
.menu-item-signout {
  color: #6b7280;
}
.menu-item-signout:hover {
  background: #fef2f2;
  color: #b91c1c;
}
.menu-item-signout .menu-icon {
  color: #9ca3af;
}
.menu-item-signout:hover .menu-icon {
  color: #dc2626;
}
</style>
